import * as React from "react";
import { connect, ActionCreator } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import styled from "styled-components";

import { openSigninModal } from "../../lib/auth";
import { Company } from "../entities";
import { companySelector } from "../selectors";
import { RootState } from "../../state";
import { followCompanyWorker, unfollowCompanyWorker } from "../actions";
import { colors } from "../../common/utils/style";
import { CurrentUser } from "../../common/actions/Auth";

import Translate from "../../common/components/Translate";

interface OwnProps {
  className?: string;
}

interface MappedProps {
  company: Company;
  currentUser: CurrentUser | null;
}

interface MappedActions {
  followCompanyWorker: ActionCreator<void>;
  unfollowCompanyWorker: ActionCreator<void>;
}

type Props = OwnProps & MappedProps & MappedActions;

class FollowButtonContainer extends React.Component<Props> {
  public render() {
    const { company, className } = this.props;
    return (
      <FollowButton className={className} onClick={this.handleClick}>
        <Translate id={`company.${company.is_following ? "following" : "follow"}`} />
      </FollowButton>
    );
  }

  private handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const { company, currentUser, followCompanyWorker, unfollowCompanyWorker } = this.props;
    if (!currentUser) {
      openSigninModal(event.nativeEvent);
      return;
    }
    if (company.is_following) {
      unfollowCompanyWorker(company);
    } else {
      followCompanyWorker(company);
    }
  };
}

const FollowButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  min-width: 90px;
  height: 26px;
  border-radius: 22px;
  border: solid 1px rgba(0, 0, 0, 0.8);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  font-size: 13px;
  &:hover {
    background-color: ${colors.lightgray1};
  }
`;

function mapStateToProps(state: RootState): MappedProps {
  const company = companySelector(state) as Company;
  const currentUser = state.auth.currentUser;
  return {
    company,
    currentUser,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      followCompanyWorker,
      unfollowCompanyWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowButtonContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/FollowButtonContainer.tsx